export default {


    _makeSortedColumnsBold: function() {
        // get the current sort for the datasource
        var me = this,
            sort = me.dataSource ? me.dataSource.sort() : [];

        var adjust = 0;
        if (this.options.detailTemplate) {
            adjust++;
        }

        // iterate over each current sort and find the corresponding grid column
        if (sort !== undefined) {
            $.each(sort, function(sortIndex, item) {

                // iterate over each column and find the match
                $.each(me.columns, function(colIndex, col) {

                    // check for equality
                    if (item.field === col.field) {

                        // select the proper column
                        var selector = ">tr>td:nth-child(" + (colIndex + 1 + adjust) + ")";

                        // find the column and add the class
                        me.tbody.find(selector).addClass("bold");
                    }
                });
            });
        }
    },

    _prepareSorting: function() {
        this.bind("sort", () => {
           this.wrapper.addClass("keepHeader");
        });
        // When the grid is disabled, prevent sorting
        this.element.find(".k-grid-header .k-link").on('click', (e) => {
            if (!this.enabled) {
                e.preventDefault();
                e.stopPropagation();
            }
        });
    }
};
